var map = {
	"./ac_milan.png": 6525,
	"./ac_monza.png": 6247,
	"./acf_fiorentina.png": 241,
	"./as_roma.png": 991,
	"./atalanta_bc.png": 7289,
	"./bologna_fc_1909.png": 3835,
	"./cagliari_calcio.png": 3547,
	"./como_1907.png": 9671,
	"./fc_empoli.png": 6907,
	"./genoa_cfc.png": 6210,
	"./hellas_verona.png": 2426,
	"./inter_milan.png": 1591,
	"./juventus_fc.png": 6343,
	"./parma_calcio_1913.png": 2761,
	"./ss_lazio.png": 4473,
	"./ssc_napoli.png": 7854,
	"./torino_fc.png": 9550,
	"./udinese_calcio.png": 2350,
	"./us_lecce.png": 7462,
	"./venezia_fc.png": 253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8374;